import {ScoresBarWidgetScoresModel} from "./scores-bar-widget.scores.model";
import {makeObservable, observable, override} from "mobx";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {DASHBOARD} from "../../../../containers/dashboard-container/dashboard-container.consts";
import {MyScoresLinkModel} from "../../../../containers/my-scores-container/models/my-scores-container-link-model";
import {MY_SCORES_CONTAINER} from "../../../../containers/my-scores-container/my-scores-container.consts";
import {SCORES_BAR} from "../../scores-bar-widget.consts";
import {ScoresBarWidgetTerms} from "../../scores-bar-widget.terms";
import {DatetimeUtils} from "../../../../infrastructure/utils/datetime-utils";

export class ScoresBarWidgetMyScoresModel extends ScoresBarWidgetScoresModel {
  @observable myScoresPage: Number;

  constructor(context: Number, currentLinkModel: BaseLinkModel, terms: ScoresBarWidgetTerms, datetimeUtils: DatetimeUtils) {
    super(context, currentLinkModel, terms, datetimeUtils);

    this.myScoresPage = 0;

    makeObservable(this);
  }

  @override get entityId(): Number {
    return null;
  }

  @override get dateLabel(): String {
    const dataLabel: String = `${this.datetimeUtils.toShortNamedDate(this.startDate)} - ${this.datetimeUtils.toShortNamedDate(this.endDate)}`

    return dataLabel
  }

  @override get arrowPrevLabel(): String {
    const arrowPrevLabel: String = this.terms.WEB_MY_SCORES_PREVIOUS;

    return arrowPrevLabel;
  }

  @override get arrowNextLabel(): String {
    const arrowNextLabel: String = this.terms.WEB_MY_SCORES_NEXT;

    return arrowNextLabel;
  }

  @override get linkType(): MyScoresLinkModel {
    return MyScoresLinkModel
  }

  @override get linkModel(): BaseLinkModel {
    return new MyScoresLinkModel(DASHBOARD.FILTERS.all);
  }

  @override get arrowsClick(): String {
    return SCORES_BAR.ACTION_TYPES.onMyScoresPageChange
  }

  @override get arrowClickType(): String {
    return SCORES_BAR.ANALYTICS.ARROW_CLICK_TYPE.arrows;
  }

  @override get shouldRenderLiveToggle(): Boolean {
    return this.isMainPage;
  }

  get isMainPage(): BaseLinkModel {
    return this.myScoresPage === 0
  }

  get showRecentlyEnded(): Boolean {
    const now = new Date();
    const date = new Date().setHours(SCORES_BAR.recentlyEndedViewHours, 0, 0, 0);

    return this.isMainPage && date > now
  }

  get startDate(): Date {
    let daysOffset: Number = 0;

    if (this.myScoresPage < 0) {
      daysOffset = this.myScoresPage * MY_SCORES_CONTAINER.WEEK_DAYS;
    } else if (this.myScoresPage > 0) {
      daysOffset = (MY_SCORES_CONTAINER.CURRENT_DATES_RANGE - 1) + ((this.myScoresPage > 0 ? this.myScoresPage - 1 : 0) * MY_SCORES_CONTAINER.WEEK_DAYS) + 1;
    } else if (this.showRecentlyEnded) {
      daysOffset = -1;
    }

    let date: Date = this.datetimeUtils.addDays(new Date(), daysOffset);

    return new Date(date.setHours(0, 0, 0, 0));
  }

  get endDate(): Date {
    let date: Date;

    let daysOffset: Number = MY_SCORES_CONTAINER.CURRENT_DATES_RANGE - 1;

    if (!this.isMainPage) {
      daysOffset = MY_SCORES_CONTAINER.WEEK_DAYS - 1;
    }

    date = this.datetimeUtils.addDays(this.startDate, daysOffset);

    return date;
  }

  @override get shouldRenderDate(): Boolean {
    return true;
  }
}
